module.exports = __webpack_public_path__ + "static/media/word.b425027a.svg";